const ENDPOINT = '/api/v1/launchdarkly/track-event';
const MAX_BODY_LENGTH = 60000;

let pageviewId = null;

export function resetLaunchDarklyPageviewId() {
  pageviewId = null;
}

function randomId() {
  if (globalThis.crypto && typeof globalThis.crypto.randomUUID === 'function') {
    return globalThis.crypto.randomUUID();
  }

  const bytes = new Uint8Array(16);

  if (
    globalThis.crypto &&
    typeof globalThis.crypto.getRandomValues === 'function'
  ) {
    globalThis.crypto.getRandomValues(bytes);
  } else {
    for (let index = 0; index < bytes.length; index += 1) {
      bytes[index] = Math.floor(Math.random() * 256);
    }
  }

  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0'));

  return `${hex.slice(0, 4).join('')}-${hex.slice(4, 6).join('')}-${hex.slice(6, 8).join('')}-${hex.slice(8, 10).join('')}-${hex.slice(10).join('')}`;
}

function currentPageviewId() {
  if (!pageviewId) {
    pageviewId = randomId();
  }

  return pageviewId;
}

function launchDarklyEnabled() {
  return Boolean(globalThis.window?.config?.launchDarkly?.enabled);
}

/**
 * Send a browser metric. event_id and pageview_id are stored in data.
 * Navigation events use sendBeacon, and fetch keepalive only when sendBeacon
 * is missing or returns false. The fallback reuses the same body.
 */
export function sendLaunchDarklyMetric(eventName, data = {}, options = {}) {
  if (!launchDarklyEnabled()) {
    return false;
  }

  const payload = {
    event_name: eventName,
    data: {
      ...data,
      event_id: data.event_id || randomId(),
      pageview_id: data.pageview_id || currentPageviewId(),
    },
  };
  const body = JSON.stringify(payload);

  if (body.length > MAX_BODY_LENGTH) {
    return false;
  }

  if (options.transport === 'axios') {
    const client = globalThis.axios || globalThis.window?.axios;

    if (client && typeof client.post === 'function') {
      client.post(ENDPOINT, payload).catch(function () {});
    }

    return true;
  }

  const beacon =
    globalThis.navigator &&
    typeof globalThis.navigator.sendBeacon === 'function'
      ? globalThis.navigator.sendBeacon.bind(globalThis.navigator)
      : null;
  let delivered = false;

  if (beacon) {
    delivered = beacon(
      ENDPOINT,
      new Blob([body], { type: 'application/json' }),
    );
  }

  if (!delivered && typeof globalThis.fetch === 'function') {
    globalThis
      .fetch(ENDPOINT, {
        method: 'POST',
        body,
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
      })
      .catch(function () {});
  }

  return true;
}
